import styled from 'styled-components/native'

export const RootContainer = styled.View`
  flex: 1;
`
